import { Link, useLocation } from 'react-router-dom'
import './Navigation.scss'

const Navigation = () => {
  const location = useLocation()
  const isHomePage = location.pathname === '/'

  // For home page, render as content (not fixed navigation)
  if (isHomePage) {
    return (
      <div className="splash-nav-list">
        <Link 
          to="/about" 
          className="splash-nav-link"
        >
          About
        </Link>
        <Link 
          to="/history" 
          className="splash-nav-link"
        >
          History
        </Link>
        <Link 
          to="/itinerary" 
          className="splash-nav-link"
        >
          Itinerary
        </Link>
      </div>
    )
  }

  // For other pages, render as fixed top navigation
  return (
    <nav className="navigation navigation--top">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          Ford Air Tour
        </Link>
        <div className="nav-links">
          <Link 
            to="/" 
            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
          >
            Home
          </Link>
          <Link 
            to="/about" 
            className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}
          >
            About
          </Link>
          <Link 
            to="/history" 
            className={`nav-link ${location.pathname === '/history' ? 'active' : ''}`}
          >
            History
          </Link>
          <Link 
            to="/itinerary" 
            className={`nav-link ${location.pathname === '/itinerary' ? 'active' : ''}`}
          >
            Itinerary
          </Link>
        </div>
      </div>
    </nav>
  )
}

export default Navigation